import styled, { css } from 'styled-components'

import { BodyText, Title } from '@/containers/styles'

export const EventHeadingWrapper = styled.div`
  position: relative;
  width: 100%;
`
export const StyledTitle = styled(Title)`
  line-height: 1.2em;
  margin-bottom: 20px;
  padding-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
`
export const Label = styled.div`
  position: relative;
  height: 24px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.tiles.text};
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  padding: 0 0.8em;
  border-radius: 12px;
  box-shadow: 0 0 2px
    ${({ theme }) => `rgba(${theme.colors.tiles.shading}, 0.4)`};
`

export const TimeLabel = styled(Label)<{
  $isLiveNow: boolean
  $isToday?: boolean
  $isLive?: boolean
}>`
  background: ${({ $isLive, $isLiveNow, $isToday, theme }) =>
    $isLive || $isLiveNow
      ? theme.colors.badgeLiveBg
      : $isToday
      ? theme.colors.badgeTimeBg
      : theme.colors.text};
  color: ${({ $isLive, $isLiveNow, $isToday, theme }) =>
    $isLive || $isLiveNow
      ? theme.colors.text
      : $isToday
      ? theme.colors.textDark
      : theme.colors.primary};
  padding: ${({ $isLiveNow }) =>
    $isLiveNow ? '0 0.8em 0 calc(1em + 4px)' : '0 0.8em'};
  &:before {
    ${({ $isLiveNow, theme }) =>
      $isLiveNow &&
      css`
        width: 6px;
        height: 6px;
        background: ${theme.colors.text};
        border-radius: 50%;
        content: '';
        display: block;
        z-index: 1;
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
        animation: blink 1s infinite alternate;
      `}
  }
  @keyframes blink {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`
export const PremiumLabel = styled(Label)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.textDark};
  padding: 0 0.8em 0 0.6em;
`
export const LabelIcon = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 4px;
  object-fit: contain;
`
export const PurchasedLabel = styled(PremiumLabel)``

export const NonWatchableLabel = styled(Label)`
  display: flex;
  align-items: center;
  padding: 0 0.8em 0 0.6em;
`

export const LockIcon = styled.img`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 4px;
`
export const BodyTextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  & ${BodyText} {
    margin-right: 8px;
  }
  & ${Label} {
    margin: 4px 12px 4px 0;
  }
`
